'use es6';

import { rich_text, raw_html, form } from 'DesignData/enums/SmartWidgetTypes';
import SmartProperties from 'DesignData/enums/SmartProperties';
import { pick } from 'underscore';
const TargetTypes = Object.freeze({
  default: 'WIDGET',
  [raw_html]: 'CUSTOM_HTML_WIDGET',
  [form]: 'FORM_WIDGET'
});
const TargetContentTypes = Object.freeze({
  default: 'value',
  [rich_text]: 'html'
});
export function getSmartProperties(props) {
  return pick(props, SmartProperties);
}
export function getTargetType(widgetType) {
  return TargetTypes[widgetType] || TargetTypes.default;
}
export function getTargetContentType(widgetType) {
  return TargetContentTypes[widgetType] || TargetContentTypes.default;
}
export function getTargetedContent(widgetType, props) {
  const targetContentType = getTargetContentType(widgetType);
  return {
    [targetContentType]: props[targetContentType] || ''
  };
}
export function getSmartObjectDataFromCriterion(criterion, targetType) {
  return {
    criterion_id: criterion.id,
    order: criterion.precedence,
    target_type: targetType
  };
}
export function updateWidgetWithClonedDefinition(widget, clonedDefinition) {
  const {
    criteria,
    id
  } = clonedDefinition;
  return Object.assign({}, widget, {
    params: Object.assign({}, widget.params, {
      definition_id: id,
      smart_objects: widget.params.smart_objects.reduce((acc, smartRule) => {
        const matchingCriteria = criteria.find(c => c.clonedFrom === smartRule.criterion_id);

        if (matchingCriteria) {
          return acc.concat(Object.assign({}, smartRule, {
            criterion_id: matchingCriteria.id
          }));
        }

        return acc;
      }, [])
    })
  });
}